<template>
    <div>
        <span class="link" @click="showModal();">Download app</span>

        <modal name="downloadAppModal" height="auto">
            <div class="modal-header">
                <h5 class="mb-0">Benyt vores web-app</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-2">
                        <img src="https://www.static.navinem.dk/images/logo/icon/ios/ios_icon_180px.png" alt="iOS_icon" class="img-fluid">
                    </div>
                    <div class="col-sm-10">
                        <p>
                            Vores web-app installeres gennem din browser din fra telefon eller tablet, og installationen er ganske simpel. Følg vores guide nedenfor for at komme i gang.
                        </p>
                        <h6>Sådan gør du</h6>
                        <p>
                            <span class="mr-2">-</span> Åben denne side på din telefon eller tablet.
                        </p>
                        <p>
                            <span class="mr-2">-</span> Klik på menu-ikonet i browseren.
                        </p>
                        <p>
                            <span class="mr-2">-</span> Klik "Tilføj til hjemmeskærm".
                        </p>
                        <p>
                            <span class="mr-2">-</span> Følg instrukserne på skærmen.
                        </p>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    methods: {
        showModal() {
            this.$modal.show('downloadAppModal');
        },
        hideModal() {
            this.$modal.hide('downloadAppModal');
        }
    }

}
</script>
